import React from "react";
import { Grid, Typography, CardContent } from "@mui/material";
import { AdminTitleHolder } from "../../../common/sharedComponents/styles/card.style";
import { useSelector } from "react-redux";
import { useParams } from "react-router-dom";
import {
  StyledCard,
  VendorCardLabel,
} from "../../vendorRegistration/components/StepMain";

function BusinessUnitViewDetails() {
  const { businessUnitDetails } = useSelector((state) => state.businessUnit);
  const { id } = useParams();

  return (
    <>
      <AdminTitleHolder>
        <Grid container spacing={1}>
          <Grid item xs={12}>
            Business Unit#{id}
          </Grid>
        </Grid>
      </AdminTitleHolder>
      <StyledCard>
        <CardContent>
          <Grid container spacing={2}>
            <Grid item xs={6} md={6}>
              <Typography className="label">NAME</Typography>
              <VendorCardLabel>
                {businessUnitDetails?.businessUnit?.businessUnitName || "-"}
              </VendorCardLabel>
            </Grid>
            <Grid item xs={6} md={6}>
              <Typography className="label">DESCRIPTION</Typography>
              <VendorCardLabel>
                {businessUnitDetails?.businessUnit?.businessUnitDesc || "-"}
              </VendorCardLabel>
            </Grid>
          </Grid>
        </CardContent>
      </StyledCard>
    </>
  );
}

export default BusinessUnitViewDetails;
